// extracted by mini-css-extract-plugin
module.exports = {"mainWindow":"Tools_mainWindow__29v5R"};